import {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {SubInner} from '../../atoms/CommonParts';
import config from '../../../config';
import {useApp} from '../../../contexts/AppContext';
import {
  ButtonLayout,
  useCustomDialog,
} from '../../../contexts/CustomDialogContext';

import {PageSubTitle} from '../../atoms/CommonParts';

const Page = styled.div`
`;

const LoginContent = styled.div`
  padding-top: 0px;
  @media ${config.layout.wide} {
    padding-top: 0px;
  }
`;

const PageTitle = styled.div`
  margin-top: 60px;

  h1 {
    font-size: 24px;
    font-weight: bold;
    line-height: 1;
    text-align: center;
    width: 100%;
  }
`;

const DontHaveOne = styled.div`
  width: 242px;
  @media ${config.layout.wide} {
    width: 400px;
    padding: 38px 0;
  }
  border: 1px solid #000000;
  margin: 50px auto 0;
  text-align: center;
  padding: 28px 0;

  p {
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
    color: #000000;
    @media ${config.layout.wide} {
      font-size: 18px;
    }
  }

  a {
    color: #000000;
    text-decoration: underline;
    font-size: 16px;
    font-weight: 500;
    @media ${config.layout.wide} {
      font-size: 16px;
    }
  }
`;

export default function BetaFirmwareDLPage() {
  const {customDialog} = useCustomDialog();
  const app = useApp();

  function handleSubmit(event) {
    event.preventDefault();

    //window.location.href = 'https://kuvo.com/venue/assets/files/CDJ3Kv204KUVO4.UPD';

    (async function() {
      await customDialog({
        buttons: ButtonLayout.None,
        description_element: (
            <span>The download option of the Beta firmware is currently
              unavailable. <Link to={"/contact/"}>Contact us</Link> for any questions.</span>
        ),
      });
    })();
  }

  useEffect(() => {
    app.showHeader();
    document.title = 'CDJ-3000 Beta firmware download';
  }, []);

  return (
      <Page>
        <PageSubTitle><span>Firmware download</span></PageSubTitle>
        <PageTitle><h1>CDJ-3000 Beta firmware download</h1></PageTitle>
        <form onSubmit={handleSubmit}>
          <SubInner>
            <LoginContent>

              <button
                  type="submit"
                  className="dark-button center-fixed primary"
                  style={{
                    margin: '50px  auto 0',
                  }}
              >
                <span>Firmware download</span>
              </button>

              <DontHaveOne>

                <a
                    href="https://www.pioneerdj.com/-/media/pioneerdj/downloads/firmwares/players/cdj-3000/cdj-3000_updateguide-en.pdf"
                    target="_blank"
                    rel="noopener"
                >
                  Firmware update instruction
                </a>
              </DontHaveOne>
            </LoginContent>
          </SubInner>
        </form>
      </Page>
  );
}
